import { ROUTES } from '@/routes/constants';

type NotificationAction = {
  cta?: string;
  redirect?: string | ((n: any) => string | undefined);
  state?: Record<string, any> | ((n: any) => Record<string, any> | undefined);
};

export const notificationActions: Record<string, NotificationAction> = {
  campaign_live: {
    cta: 'View Campaign',
    redirect: ROUTES.ACTIVE_CAMPAIGN,
  },

  campaign_scheduled: {
    cta: 'Review',
    redirect: ROUTES.SCHEDULED_CAMPAIGN,
  },

  campaign_just_went_live: {
    cta: 'View',
    redirect: ROUTES.ACTIVE_CAMPAIGN,
  },

  campaign_paused: {
    cta: 'Resume',
    redirect: ROUTES.ACTIVE_CAMPAIGN,
    state: { tab: 'paused' },
  },
  campaign_completed: {
    cta: 'View Results',
    redirect: (n) =>
      n.params?.campaignId
        ? ROUTES.CAMPAIGN.replace(':id', n.params.campaignId)
        : undefined,
    state: { from: 'completed' },
  },

  connect_social_accounts: {
    cta: 'Connect',
    redirect: `${ROUTES.PROFILE}?tab=social`,
  },
  funds_added: {
    cta: 'View Wallet',
    redirect: ROUTES.WALLET,
  },
  smartlink_is_live: {
    cta: 'Copy Link',
    redirect: ROUTES.MY_LINKS,
  },
  team_member_added: {
    cta: 'Manage Team',
    redirect: ROUTES.USER_MANAGEMENT,
  },
  first_claim_received: {
    cta: 'Review',
    redirect: (n) =>
      n.params?.campaignId
        ? ROUTES.CAMPAIGN.replace(':id', n.params.campaignId)
        : undefined,
  },
  submission_milestone: {
    cta: 'View Analytics',
    redirect: (n) =>
      n.params?.campaignId
        ? ROUTES.CAMPAIGN.replace(':id', n.params.campaignId)
        : undefined,
  },
  sales_milestone_hit: {
    cta: 'View Analytics',
    redirect: (n) =>
      n.params?.campaignId
        ? ROUTES.CAMPAIGN.replace(':id', n.params.campaignId)
        : undefined,
  },
  smartlink_insights: {
    cta: 'View Analytics',
    redirect: ROUTES.MY_LINKS,
    state: (n) => ({
      openSmartLinkDetailsModal: true,
      smartLinkFromNotification: n.params?.link,
      source: 'notification',
      notificationType: n.notificationType,
    }),
  },
  wallet_empty: {
    cta: 'Add Funds',
    redirect: ROUTES.WALLET,
  },
  balance_running_low: {
    cta: 'Add Funds',
    redirect: ROUTES.WALLET,
  },
  campaign_goes_live_soon: {
    cta: 'Review',
    redirect: ROUTES.SCHEDULED_CAMPAIGN,
  },
  draft_saved: {
    cta: 'Continue',
    redirect: ROUTES.ACTIVE_CAMPAIGN,
    state: { tab: 'draft' },
  },
  weekly_report_ready: {
    cta: 'View Report',
    redirect: (n) =>
      n.params?.campaignId
        ? ROUTES.CAMPAIGN.replace(':id', n.params.campaignId)
        : undefined,
  },
  traffic_spike_detected: {
    cta: 'View Analytics',
    redirect: ROUTES.MY_LINKS,
    state: (n) => ({
      openSmartLinkDetailsModal: true,
      smartLinkFromNotification: n.params?.link,
      source: 'notification',
      notificationType: n.notificationType,
    }),
  },
};
